<template>
  <div class="visit_class">
    <div :class="MAIN_CLASS">
      <!-- bread -->
      <div class="bread_nav clearfix">
        <div class="return clearfix" @click="$router.go(-1)">
          <img v-if="URL_MAQIN==2" src="../assets/img/kjc返回.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/返回.png" alt />
          返回上一页
        </div>
        <div
          class="time_left clearfix"
          v-if="chapter_info.course_type==2&&has_exam_date!=0 ||chapter_info.course_type==3&&has_exam_date!=0"
        >
          <img v-if="URL_MAQIN==2" src="../assets/img/kjctime.png" alt />
          <img v-if="URL_MAQIN==1" src="../assets/img/time.png" alt />

          <div class="text" v-if="!tip">
            距离考试还有
            <span>{{exam_time}}</span> 天，抓紧时间学习啦
          </div>
          <div class="text" v-else>
            {{tip}}
          </div>
        </div>
        <div class="class_Schedule" @click="Class_Schedule" v-show="false">
          <img src="../assets/img/Timetable.png" alt />
          查看课表
        </div>
      </div>
      <div class="content_box clearfix">
        <div class="content_box_l">
          <div class="content_box_l_title">已报课程</div>
          <div
            class="class_list"
            :class="item.title==chapter_info.title?'active':''"
            v-for="(item,index) in title_list"
            :key="index"
            @click="chuange_class(item.course_id,item.chapter_id)"
          >{{item.title}}</div>
        </div>
        <div class="content_box_r">
          <div class="class_top">
            <!-- 课程有效时间 -->
            <div class="valid_time">
              课程有效时间：
              <span>{{chapter_info.expire_time}}</span>
            </div>
            <div class="module clearfix">
              <div class="module_item clearfix" @click="handout_click" v-if="chapter_info.is_word==1">
                <span>{{chapter_info.learn_type!=3?'下载讲义':'资料讲义'}}</span>
                <img v-if="URL_MAQIN==2" src="../assets/img/kjc下载讲义.png" alt />
                <img v-if="URL_MAQIN==1" src="../assets/img/下载讲义.png" alt />
              </div>
              <div
                class="module_item clearfix"
                @click="make_click"
                v-if="chapter_info.course_type==2&&chapter_info.is_exam==1 ||chapter_info.course_type==3&&chapter_info.is_exam==1"
              >
                <span>做题</span>
                <img v-if="URL_MAQIN==2" src="../assets/img/kjc做题.png" alt />
                <img v-if="URL_MAQIN==1" src="../assets/img/做题.png" alt />
              </div>
              <!-- 模考试卷 -->
               <div
                class="module_item clearfix"
                @click="go_chapter_by_mock"
                v-if="chapter_info.course_type==7"
              >
                <span>模考试卷</span>
                <img v-if="URL_MAQIN==2" src="../assets/img/kjc做题.png" alt />
                <img v-if="URL_MAQIN==1" src="../assets/img/做题.png" alt />
              </div>

              <div class="module_item clearfix" @click="join_click" v-if="chapter_info.is_join==1">
                <span>{{addClassContent.title||'加入班群'}}</span>
                <img v-if="URL_MAQIN==2" src="../assets/img/kjcjoin.png" alt />
                <img v-if="URL_MAQIN==1" src="../assets/img/join.png" alt />
              </div>

              <div class="module_item clearfix" style="background: #ffffff;border: 2px solid #FADA1E;" @click="goShicao" v-if="has_shicao==1">
                <span>实操练习</span>
                <img src="../assets//我的作业.png" alt />
              </div>
            </div>
            <div class="progress clearfix">
              <span>课程完成进度：</span>
              <div class="progress_c">
                <el-progress :percentage="progress" :stroke-width="16"></el-progress>
              </div>
            </div>
            <div
              class="keep_class clearfix"
              v-show="Previous_class.chapter_id"
              @click="keep_cilck(Previous_class)"
            >
              <span>上次学到 {{Previous_class.title}}</span>
              <img v-if="URL_MAQIN==2" src="../assets/img/kjc播放.png" alt />
              <img v-if="URL_MAQIN==1" src="../assets/img/播放.png" alt />
            </div>
          </div>
          <div class="class_bottom"> <!--:style="{'padding-bottom':padding_bottom}"-->
            <div class="class_item" v-for="(item,index) in chapter_list" :key="index">
              <div class="class_item_title clearfix" @click.stop="showNav(index,item)" v-if="item.video">
                <span></span>
                <div class="name">{{item.title}} （{{item.video? item.video.length:'0'}}）</div>
                <div class="class_list_title_r" v-if="item.is_lock==1">
                  <img v-if="item.show" src="../assets/img/up.png" alt />
                  <img v-else src="../assets/img/down.png" alt />
                  <i v-show="item.showSort" @click.stop="changeSort(item)">切换倒序</i>
                  <i v-show="!item.showSort" @click.stop="changeSort(item)">切换正序</i>
                </div>
                
                <div class="class_list_title_r" v-if="item.is_lock==0">{{item.lock_mark}}</div>
              </div>
              <div class="class_item_title clearfix" v-else>
                <div class="name">{{item.title}}</div>
                <div class="class_list_title_r">
                  <div class="operate" v-if="item.is_lock==0">{{item.lock_mark}}</div>
                  <!-- <div class="operate red" v-if="item1.type==1">{{item1.lock_mark}}</div> -->
                  <div class="operate clearfix" v-else>
                    <div class="zhibo" v-if="item.type==1">{{item.lock_mark}}</div>
                    <div class="min_box" v-else>
                      <div class="propge">
                        <el-progress :percentage="parseInt(item.progress)" :stroke-width="10"></el-progress>
                      </div>

                    </div>
                    <div class="btn_box">
                        <div class="btn" v-if="item.work_id>0" @click="practice_click(item)">做作业</div>
                        <div
                          class="btn"
                          v-if="item.type==1 && item.is_lock !='0'"
                          @click="Live(item)"
                        >查看直播</div>
                        <div class="btn"  v-if="item.type!=1 && item.is_lock !='0'" @click="playback_click(item)">看回放</div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="class_item_content" v-if="item.show">
                <div
                  class="class_child_list clearfix"
                  v-for="(item1,index) in item.video"
                  :key="index"
                >
                  <div @click="changeShow(item1)" style="cursor:pointer;padding:16px 0;border-bottom:1px solid #EEEEEE;overflow: hidden;width: 100%;padding-left: 22px;">

                    <div class="tag_number" v-if="!item1.son">{{item1.sort}}</div>

                    <div class="class_child_list_name" >{{item1.title}}</div>
                    <div class="detail"></div>
                    <div class="operate" v-if="item1.is_lock==0||item1.son&&item1.son.length>0">
                      {{item1.lock_mark}}
                      <div class="right" v-if="item1.chapter_count">
                        已学完{{item1.finished_count||0}}/{{item1.chapter_count||0}}
                        <img src="../assets/img/up2.png" alt="" style="margin-left:18px;width:18px" v-show="item1.isShow">
                        <img src="../assets/img/down2.png" alt="" style="margin-left:18px;width:18px" v-show="!item1.isShow">
                      </div>
                    </div>
                    <!-- <div class="operate red" v-if="item1.type==1">{{item1.lock_mark}}</div> -->
                    <div class="operate clearfix" v-else>
                      <div class="zhibo" v-if="item1.type==1">{{item1.lock_mark}}</div>
                      <div class="min_box" v-else>
                        <div class="propge">
                          <el-progress :percentage=" parseInt(item1.progress)" :stroke-width="10"></el-progress>
                        </div>
                      </div>
                      <div class="btn_box">
                        <div class="btn" v-if="item1.work_id>0" @click="practice_click(item1)">做作业</div>
                        <div
                          class="btn"
                          v-if="item1.type==1 && item1.is_lock !=0"
                          @click="Live(item1)"
                        >查看直播</div>
                        <div
                          class="btn"
                          @click="playback_click(item1)"
                          v-if="item1.type!=1 && item1.is_lock !=0"
                        >看回放</div>
                      </div>
                    </div>

                    
                  </div>


                  <!-- 三级 -->
                  <div v-for="(item2,index2) in item1.son" :key="index2" style="padding:16px 0;border-bottom:1px solid #EEEEEE;overflow: hidden;width: 100%;padding-left: 22px;" v-show="item1.isShow">
                    <div class="tag_number">{{item2.sort}}</div>
                    <div class="class_child_list_name">{{item2.title}}</div>
                    <div class="detail"></div>
                    <div class="operate clearfix">
                      <div class="zhibo" v-if="item2.type==1">{{item2.lock_mark}}</div>
                      <div class="min_box" v-else>
                        <div class="propge">
                          <el-progress :percentage=" parseInt(item2.progress)" :stroke-width="10"></el-progress>
                        </div>
                      </div>
                      <div class="btn_box">
                        <div class="btn" v-if="item2.work_id>0" @click="practice_click(item2)">做作业</div>
                        <div
                          class="btn"
                          v-if="item1.type==1 && item2.is_lock !=0"
                          @click="Live(item2)"
                        >查看直播</div>
                        <div
                          class="btn"
                          @click="playback_click(item2)"
                          v-if="item2.type!=1 && item2.is_lock !=0"
                        >看回放</div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>
            <!-- <v-swipe v-bind:swipe_list="swipe_list" class="adClass" style="margin:40px;width:calc(100% - 80px);border-radius:8px;cursor:pointer"></v-swipe> -->

            <div class="adClass"  @click="adClick(swipe_list.link)" v-if="swipe_list">
              <img :src="swipe_list.content" alt="" style="border-radius:8px;cursor:pointer">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ClassTitle,
  ExamTime,
  ClassList,
  oneClassList,
  Previous,
  billing,
  levelContent,
  HasShicao
} from "@/api/index";
import appConfig from "@/api/appConfig";
import swipe from '../components/_swipe.vue'
export default {
  components:{
    'v-swipe':swipe
  },
  data() {
    return {
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      currentRate: 0,
      course_id: "", //课程id
      chapter_id: "", //章节id
      title_list: [], //科目标题
      exam_time: "", //考试时间
      tip:'',//考试公告
      chapter_info: {}, //课程
      chapter_list: [], //章节列表
      progress: 0, //进度条
      Previous_class: {}, //播放记录
      swipe_list:'',
      addClassContent:'',
      has_exam_date:'',
      has_shicao:0,
    };
  },
  computed:{
    padding_bottom:function(){
      let padding = '0'//95
      // if (this.swipe_list.length>0) {
      //  padding = this.swipe_list[0].height +'px'
      // }else{
      //  padding='0px'
      // }
      return padding
    }
  },
  mounted() {
    this.previous();
    this.course_id = this.$route.query.course_id;
    if (this.$route.query.chapter_id) {
      this.chapter_id = this.$route.query.chapter_id;
    } else {
      this.chapter_id = this.$route.query.course_id;
    }
    // sessionStorage.setItem("course_id",this.$route.query.course_id );
    // sessionStorage.setItem("chapter_id",this.$route.query.chapter_id );

    //改为优先读取地址栏
    if (this.$route.query.chapter_id) {
      if (
        this.$route.query.course_id&&this.$route.query.chapter_id
      ) {
        sessionStorage.setItem("course_id", this.$route.query.course_id);
        sessionStorage.setItem("chapter_id", this.$route.query.chapter_id);
        this.request(this.$route.query.course_id, this.$route.query.chapter_id);
        this.getbilling(2,this.$route.query.course_id)
      } else {
        this.request(
          sessionStorage.getItem("course_id"),
          sessionStorage.getItem("chapter_id")
        );
        this.getbilling(2,sessionStorage.getItem("course_id"))
      }
    } else {
      this.request(this.$route.query.course_id, 0);
      this.getbilling(2,this.$route.query.course_id)
    }


    this.joinClass(this.$route.query.course_id);
    this.hasShicao();
  },
  methods: {
    changeShow(item){
      let show = false
      if(!item.isShow) show = true
      else show=false
      this.$set(item,'isShow',show)
    },
    adClick(url){
      // window.location.href = url;
      window.open(url)
    },
    // 加入班群
    joinClass(course_id){
      levelContent(course_id,13).then(res=>{//this.v_id
        // console.log(res)
        this.addClassContent = res
      })
    },
    request(course_id, chapter_id) {
      ClassTitle(course_id).then(res => {
        // console.log(res);
        this.title_list = res;
      });
      ExamTime(course_id).then(res => {
        // console.log(res);
        this.has_exam_date = res.has_exam_date
        this.tip = res.exam_notice;
        this.exam_time = res.exam_time;
      });

      ClassList(chapter_id, course_id).then(res => {
        // console.log(res);
        console.log(res);
        this.chapter_info = res.chapter_info;
        if (res.progress > 100) {
          this.progress = 100;
        } else {
          this.progress = parseInt(res.progress);
        }
        let chapter_list = res.chapter_list;

        for (let i = 0; i < chapter_list.length; i++) {
          if (chapter_list[i].video) {
            //新增排序显示
            chapter_list[i].showSort=true
            for (let j = 0; j < chapter_list[i].video.length; j++) {
              chapter_list[i].video[j].progress1 =
                chapter_list[i].video[j].progress + "%";
              if (chapter_list[i].is_open == 1) {
                chapter_list[i].show = true;
              } else {
                chapter_list[i].show = false;
              }
            }
          }
        }
        console.log(chapter_list);
        this.chapter_list = chapter_list;
        //默认第一个展开
        if(this.chapter_list.length!=0)
          this.chapter_list[0].show=true
      });
    },
    getbilling(id,course_id){
      billing(id,course_id).then(res=>{
        // console.log(res,'a');
        this.swipe_list=res[0]
      })
    },
    previous() {
      Previous().then(res => {
        this.Previous_class = res;
      });
    },
    // 切换课程
    chuange_class(course_id, chapter_id) {
      this.request(course_id, chapter_id);
      this.course_id = course_id;
      this.chapter_id = chapter_id;
      sessionStorage.setItem("course_id", course_id);
      sessionStorage.setItem("chapter_id", chapter_id);
    },

    // 点击课程
    showNav(index, item) {
      if (item.is_lock == 1) {
        let Mchapter_list = this.chapter_list;
        
        for (let i = 0; i < Mchapter_list.length; i++) {
          if (index == i) {
            Mchapter_list[i].show = !Mchapter_list[i].show;
          } else {
            Mchapter_list[i].show = false;
          }
        }
        this.chapter_list = Mchapter_list;
      }
    },
    handout_click() {
      // if (this.chapter_id == this.course_id) {
      //   this.$router.push({
      //     path: "handouts",
      //     query: {
      //       chapter_id: 0,
      //       course_id: this.course_id
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: "handouts",
      //     query: {
      //       chapter_id: this.chapter_id,
      //       course_id: this.course_id
      //     }
      //   });
      // }
      this.$router.push({
        path: "handouts",
        query: {
          chapter_id: this.chapter_info.id,
          course_id: this.chapter_info.course_id
        }
      });
    },
    // 点击作业
    practice_click(item) {
      this.$router.push({
        path: "work_detail",
        query: {
          course_id: item.course_id,
          work_id: item.work_id,
          course_chapter_id: item.id
        }
      });
    },
    // 查看回放
    playback_click(item) {
      if (item.video_type == 2) {
        sessionStorage.setItem("id", item.id);
        const { href } = this.$router.resolve({
          path: "playback",
          query: {
            id: 1,
            course_id:item.course_id
          }
        });
        window.open(href, "_blank");
      } else if (item.video_type == 9) {
        let vhallUrll =
          appConfig.classUrl +
          "/play/" +
          item.id +
          "/" +
          "course_id/" +
          item.course_id +
          ".html";
        // window.location.href = vhallUrll;
        window.open(vhallUrll, "_blank");
      } else if (item.video_type == 11) {
        let ccUrl =
          appConfig.classUrl +
          "/bokecc/" +
          item.id +
          "/" +
          item.course_id +
          ".html";
        // window.location.href = ccUrl;
        window.open(ccUrl, "_blank");
      }
    },
    // 点击做题
    make_click() {
      this.$router.push({
        path: "question_bank",
        query: {
         chapter_id: this.chapter_info.id,
          course_id: this.chapter_info.course_id,
          name: this.chapter_info.title
        }
      });
    },
    // 点击模考试卷
    go_chapter_by_mock() {

      let _this = this;
      this.$router.push({
        path: "exam_list",
        query: {
          course_id: this.chapter_info.course_id,
          id: this.chapter_info.exam_id,
          title: this.chapter_info.exam_title,
        }
      });

    },
    join_click() {
      this.$router.push({
        path: "join",
        query: {
         chapter_id: this.chapter_info.id,
          course_id: this.chapter_info.course_id,
          type:this.addClassContent.title||'加入班群'
        }
      });
    },

    // 直播
    Live(item) {
      let ccUrl =
        appConfig.classUrl +
        "/bokecc/" +
        item.id +
        "/" +
        item.course_id +
        ".html";
      let vhallUrll =
        appConfig.classUrl +
        "/play/" +
        item.id +
        "/" +
        "course_id/" +
        item.course_id +
        ".html";
      if (item.video_type == 11) {
        // window.location.href = ccUrl;
        window.open(ccUrl, "_blank");
      } else if (item.video_type == 9) {
        // window.location.href = vhallUrll;
        window.open(vhallUrll, "_blank");
      }
      //  console.log(url+'/bokecc/'+'/'+item.id+'/'+item.course_id+'.html');
      //  'http://class.t.mifengdao.com/play/{chapter_id}/course_id/{course_id}.html'
      //  window.location.href=url+117+118./bokecc
    },
    // 继续播放
    keep_cilck(item) {
      if (item.video_type == 2) {
        sessionStorage.setItem("id", item.chapter_id);
        const { href } = this.$router.resolve({
          path: "playback",
          query: {
            id: 1,
            course_id:item.course_id
          }
        });
        window.open(href, "_blank");
      } else if (item.video_type == 9) {
        let vhallUrll =
          appConfig.classUrl +
          "/play/" +
          item.chapter_id +
          "/" +
          "course_id/" +
          item.course_id +
          ".html";
        // window.location.href = vhallUrll;
        window.open(vhallUrll, "_blank");
      } else if (item.video_type == 11) {
        let ccUrl =
          appConfig.classUrl +
          "/bokecc/" +
          item.chapter_id +
          "/" +
          item.course_id +
          ".html";
        window.open(ccUrl, "_blank");
      }
    },
    Class_Schedule(){
      this.$router.push({path:'class_schedule'})
    },
    changeSort(item){
      item.video = item.video.reverse()
      item.showSort = !item.showSort
    },
    hasShicao() {
        HasShicao().then((res) => {
            this.has_shicao = res.has_shicao;
        });
    },
    goShicao(){
        window.open(`${appConfig.shicaoUrl}`)
    }
  }


};
</script>
<style lang="scss" scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 23px 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;

    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 162px;
      line-height: 28px;
      margin-top: 5px;
      cursor: pointer;

      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }

    .time_left {
      float: left;

      img {
        float: left;
        width: 31px;
        height: 31px;
        margin-right: 16px;
      }

      .text {
        float: left;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        span {
          color: #fe4c4b;
          font-size: 26px;
          font-weight: Medium;
        }
      }
    }
    .class_Schedule {
      cursor: pointer;
      float: right;
      width: 112px;
      height: 32px;
      background: rgba(250, 220, 30, 1);
      border-radius: 4px;
      line-height: 32px;
      img {
        margin: 5px 10px 0 10px;
        float: left;
        width: 22px;
        height: 22px;
      }
    }
  }

  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);

      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }

      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }

      .active {
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        background: rgba(250, 220, 30, 1);
      }
    }

    .content_box_r {
      float: right;
      width: 1067px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
       margin-bottom: 95px;
      .class_top {
        padding: 27px 0 37px 40px;
        border-bottom: 1px #eee;
        .valid_time {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          span {
            color: #fe4c4b;
          }
        }
        .module {
          margin-bottom: 46px;

          .module_item {
            cursor: pointer;
            float: left;
            margin-right: 51px;
            width: 146px;
            background: rgba(250, 220, 30, 1);
            border-radius: 5px;
            padding: 13px 0;

            span {
              display: block;
              float: left;
              width: 40px;
              font-size: 20px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              margin-left: 25px;
            }

            img {
              float: right;
              width: 58px;
              height: 58px;
              margin-right: 6px;
            }
          }
        }

        .progress {
          margin-bottom: 30px;

          span {
            float: left;
          }

          .progress_c {
            width: 348px;
            float: left;
            margin-left: 24px;
          }
        }

        .keep_class {
          cursor: pointer;
          span {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 31px;
          }

          img {
            width: 31px;
            height: 31px;
            float: left;
            margin-left: 16px;
          }
        }
      }

      .class_bottom {
        padding: 32px 50px 80px 50px;
        position: relative;
        .class_item {
          margin-bottom: 32px;

          .class_item_title {
            padding-bottom: 24px;
            border-bottom: 1px solid #eee;
            cursor: pointer;

            span {
              display: block;
              float: left;
              width: 8px;
              height: 24px;
              background: rgba(250, 220, 30, 1);
              margin-right: 37px;
            }

            .name {
              float: left;
              font-size: 20px;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
            }

            .class_list_title_r {

              >img {
                margin-left: 20px;
                width: 26px;
                height: 26px;
              }
              i{
                float: right;
                font-style: normal;
              }
              .operate {
                float: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                width: 520px;
                text-align: right;
                position: relative;
                .zhibo {
                   position: absolute;
                  right: 91px;
                  top: 4px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #fe4c4b;
                }

                .propge {
                  float: left;
                  width: 261px;
                  margin-right: 36px;
                  margin-top: 5px;
                }
                .btn_box {
                  float: right;
                  .btn {
                    cursor: pointer;
                    float: left;
                    width: 72px;
                    height: 24px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 4px;
                    border: 1px solid rgba(151, 151, 151, 1);
                    font-size: 12px;
                    font-weight: 500;
                    color: rgba(102, 102, 102, 1);
                    text-align: center;
                    line-height: 24px;

                    &:last-of-type {
                      margin-left: 14px;
                    }
                  }
                }
              }

              .red {
                color: #fe4c4b;
              }
            }
          }

          .class_item_content {
            .class_child_list {
              // padding: 16px 0 16px 48px;
              border-bottom: 1px solid #eee;
              .tag_number {
                float: left;
                width: 32px;
                height: 17px;
                background: rgba(250, 220, 30, 1);
                border-radius: 5px;
                font-size: 14px;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                text-align: center;
                line-height: 17px;
                margin-top: 3px;
                margin-right: 10px;
              }
              .class_child_list_name {
                width: 325px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                margin-right: 23px;
                float: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .detail {
                float: left;
                width: 325px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                /*超出部分隐藏*/
                white-space: nowrap;
                /*不换行*/
                text-overflow: ellipsis;
                /*超出部分文字以...显示*/
              }

              .operate {
                float: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                width: 520px;
                text-align: right;
                position: relative;
                .zhibo {
                  // float: right;
                  // margin-left: auto;
                  position: absolute;
                  right: 91px;
                  top: 4px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #fe4c4b;
                }

                .propge {
                  float: left;
                  width: 261px;
                  margin-right: 36px;
                  margin-top: 5px;
                }
                .btn_box {
                  float: right;
                  .btn {
                    cursor: pointer;
                    float: left;
                    width: 72px;
                    height: 24px;
                    background: #FFFFFF;
                    border-radius: 12px;
                    border: 1px solid #FADA1E;
                    font-size: 12px;
                    font-weight: 500;
                    color: rgba(102, 102, 102, 1);
                    text-align: center;
                    line-height: 24px;

                    &:last-of-type {
                      margin-left: 14px;
                    }
                  }
                }
              }

              .red {
                color: #fe4c4b;
              }
            }
          }
        }
      }
    }
  }
}
.main_kjc {
  .bread_nav {
    padding: 12px 23px 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;

    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 162px;
      line-height: 28px;
      margin-top: 5px;
      cursor: pointer;

      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }

    .time_left {
      float: left;

      img {
        float: left;
        width: 31px;
        height: 31px;
        margin-right: 16px;
      }

      .text {
        float: left;
        font-size: 18px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        span {
          color: #fe4c4b;
          font-size: 26px;
          font-weight: Medium;
        }
      }
    }
    .class_Schedule {
      cursor: pointer;
      float: right;
      width: 112px;
      height: 32px;
      background: rgba(250, 220, 30, 1);
      border-radius: 4px;
      line-height: 32px;
      img {
        margin: 5px 10px 0 10px;
        float: left;
        width: 22px;
        height: 22px;
      }
    }
  }

  .content_box {
    .content_box_l {
      float: left;
      width: 268px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(238, 238, 238, 1);

      .content_box_l_title {
        padding: 24px 0;
        border-bottom: 1px solid #eee;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        color: rgba(43, 43, 43, 1);
        margin-bottom: 20px;
      }

      .class_list {
        padding: 20px 0;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }

      .active {
        font-weight: 500;
        color: #fff;
        background: #0cd56d;
      }
    }

    .content_box_r {
      float: right;
      width: 1067px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);

      .class_top {
        padding: 27px 0 37px 40px;
        border-bottom: 1px #eee;
        .valid_time {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          span {
            color: #fe4c4b;
          }
        }
        .module {
          margin-bottom: 46px;

          .module_item {
            cursor: pointer;
            float: left;
            margin-right: 51px;
            width: 146px;
            background: #0cd56d;
            border-radius: 5px;
            padding: 13px 0;

            span {
              display: block;
              float: left;
              width: 40px;
              font-size: 20px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              margin-left: 25px;
            }

            img {
              float: right;
              width: 58px;
              height: 58px;
              margin-right: 6px;
            }
          }
        }

        .progress {
          margin-bottom: 30px;

          span {
            float: left;
          }

          .progress_c {
            width: 348px;
            float: left;
            margin-left: 24px;
          }
        }

        .keep_class {
          cursor: pointer;
          span {
            float: left;
            font-size: 14px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 31px;
          }

          img {
            width: 31px;
            height: 31px;
            float: left;
            margin-left: 16px;
          }
        }
      }

      .class_bottom {
        padding: 32px 50px 80px 50px;
        position: relative;
        .class_item {
          margin-bottom: 32px;

          .class_item_title {
            padding-bottom: 24px;
            border-bottom: 1px solid #eee;
            cursor: pointer;

            span {
              display: block;
              float: left;
              width: 8px;
              height: 24px;
              background: #0cd56d;
              margin-right: 37px;
            }

            .name {
              float: left;
              font-size: 20px;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
            }

            .class_list_title_r {

              >img {
                margin-left: 20px;
                width: 26px;
                height: 26px;
              }
              i{
                float: right;
                font-style: normal;
              }
              .operate {
                float: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                width: 520px;
                text-align: right;
                position: relative;
                .zhibo {
                   position: absolute;
                  right: 91px;
                  top: 4px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #fe4c4b;
                }

                .propge {
                  float: left;
                  width: 261px;
                  margin-right: 36px;
                  margin-top: 5px;
                }
                .btn_box {
                  float: right;
                  .btn {
                    cursor: pointer;
                    float: left;
                    width: 72px;
                    height: 24px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 4px;
                    border: 1px solid rgba(151, 151, 151, 1);
                    font-size: 12px;
                    font-weight: 500;
                    color: rgba(102, 102, 102, 1);
                    text-align: center;
                    line-height: 24px;

                    &:last-of-type {
                      margin-left: 14px;
                    }
                  }
                }
              }

              .red {
                color: #fe4c4b;
              }
            }
          }

          .class_item_content {
            .class_child_list {
              padding: 16px 0 16px 48px;
              border-bottom: 1px solid #eee;
              .tag_number {
                float: left;
                width: 32px;
                height: 17px;
                background: #0cd56d;
                border-radius: 5px;
                font-size: 14px;
                font-weight: 500;
                color: #fff;
                text-align: center;
                line-height: 17px;
                margin-top: 3px;
                margin-right: 10px;
              }
              .class_child_list_name {
                width: 325px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                margin-right: 23px;
                float: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .detail {
                float: left;
                width: 325px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                overflow: hidden;
                /*超出部分隐藏*/
                white-space: nowrap;
                /*不换行*/
                text-overflow: ellipsis;
                /*超出部分文字以...显示*/
              }

              .operate {
                float: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                width: 520px;
                text-align: right;
                position: relative;
                .zhibo {
                  // float: right;
                  // margin-left: auto;
                  position: absolute;
                  right: 91px;
                  top: 4px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #fe4c4b;
                }

                .propge {
                  float: left;
                  width: 261px;
                  margin-right: 36px;
                  margin-top: 5px;
                }
                .btn_box {
                  float: right;
                  .btn {
                    cursor: pointer;
                    float: left;
                    width: 72px;
                    height: 24px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 4px;
                    border: 1px solid rgba(151, 151, 151, 1);
                    font-size: 12px;
                    font-weight: 500;
                    color: rgba(102, 102, 102, 1);
                    text-align: center;
                    line-height: 24px;

                    &:last-of-type {
                      margin-left: 14px;
                    }
                  }
                }
              }

              .red {
                color: #fe4c4b;
              }
            }
          }
        }
      }
    }
  }
}
.adClass{
  // position: fixed;
  // bottom: 0;
  // left: 0;
  margin-top: 24px;
}
</style>
<style lang="scss">
.main_kjc {
  .el-progress-bar__inner {
    background-color: #0cd56d;
  }
}
.main_mfd {
  .el-progress-bar__inner {
    background-color: #fadc1e;
  }
}
.el-progress__text {
  width: 20px !important;
}
</style>
